export default "__VITE_ASSET__c917NDuS__"